const Base = require('./base');
const $ = require('cash-dom');
const CouponsPage = require('../components/coupons-page');
const Poll = require('../components/poll');
const MacrosFront = require('../components/macros');
require('../../vendor/splide.min');
const Template = require('../components/template');
const Ajax = require('../components/ajax');
require("../components/accessibility-widget");

window.galleriesHtml = [];
const BaseOrganic = {
  init() {
    Base.init();
    CouponsPage.init();
    Poll.init();
    MacrosFront.init();

    //popup for slider images
    $(document).on('click', '.popup-image', function () {
      //if slider is not in the affiliate link
      if ($(this).closest('.gallery-carousel').parent().get( 0 ).tagName !== "A") {
        const gallery = $(this).closest('.gallery-carousel'),
          galleryId = gallery.attr('id'),
          galleryIdNum = gallery.attr('id').split('_')[1];

        $('#gallery-image').html(window.galleriesHtml[galleryIdNum - 1]);
        Template.popup('#gallery-image', {}, {'className': 'gallery-image-popup'});
        const popupContent = $('.gallery-image-popup .popup-content');
        popupContent.children('.gallery-carousel').attr('id', galleryId + '_popup');
        popupContent.children('.gallery-carousel').attr('data-splide',
          '{"type":"loop","focus":"center","gap":"","pagination":"slider","arrows":true}');
        popupContent.find('img').each((i, img) => {
          $(img).removeClass('popup-image');
        });
        var slideElem = $(this).closest('.splide__slide').attr('id').split('slide')[1];
        slideElem = slideElem.charAt(0) === "0" ? slideElem.slice(1) - 1 : slideElem - 1;
        new Splide('#' +galleryId + '_popup', {
          'direction': $(document.documentElement).hasClass('is-rtl') ? 'rtl' : 'ltr',
          'start': slideElem
        }).mount();
      }
    });

    //gallery carousel
    if ($('.gallery-carousel').length) {
      $('.gallery-carousel').each((i, gallery) => {
        let galleryId = $(gallery).attr('id');

        window.galleriesHtml[i] = gallery.outerHTML;

        if (galleryId) {
          new Splide('#' + galleryId, {
            'direction': $(document.documentElement).hasClass('is-rtl') ? 'rtl' : 'ltr',
            'keyboard' : false,
            'paginationKeyboard': false
          }).mount();
        }
      });
    }

    $(document).on('click', 'label.custom-checkbox', function () {
      var el = $(this).find('input[type="checkbox"]');

      if (!el.prop('disabled')) {
        el.prop('checked', !el.prop('checked'));
        $(this).toggleClass('checked', el.prop('checked'));
      }
    });

    $(document).on('click', '.toggle-show-more', function (e) {
      e.preventDefault();

      var $content = $(this).closest('.toggle-content');

      $(this).addClass('hidden');
      $content.find('.toggle-show-less').removeClass('hidden');
      $content.find('.toggle-dots').addClass('hidden');
      $content.find('.toggle-full-content').removeClass('hidden');

    }).on('click', '.toggle-show-less', function (e) {
      e.preventDefault();

      var $content = $(this).closest('.toggle-content');

      $(this).addClass('hidden');

      $content.find('.toggle-show-more').removeClass('hidden');
      $content.find('.toggle-dots').removeClass('hidden');
      $content.find('.toggle-full-content').addClass('hidden');
    });

    $('[data-video-id]').on('click', function () {
      let video_id = $(this).data('video-id');

      if ($(this).closest('.yt-video-inner').length) {
        let iframe = '<iframe width="560" height="315" src="https://www.youtube.com/embed/' + video_id + '?feature=oembed&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen=""></iframe>';

        $(this).replaceWith(iframe);
      } else {
        let iframeHeight = $(this).height(),
          iframe = '<iframe width="100%" height="' + iframeHeight + '" src="https://www.youtube.com/embed/' + video_id + '?feature=oembed&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen=""></iframe>';

        $(this)
          .html(iframe)
          .data('video-id', null)
          .addClass('youtube-loaded', null);
      }
    });

    /** Adding .is_stuck to position:sticky element **/
    const stickyElm = document.querySelector('.sticky');
    if (stickyElm !== null) {

      let getScrollParent = function (element, includeHidden) {
        var style = getComputedStyle(element),
          excludeStaticParent = style.position === 'absolute',
          overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

        if (style.position !== 'fixed')
          for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static')
              continue;
            if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX))
              return parent;
          }

        return window;
      };

      let throttle = function (callback, limit) {
        var wait = false;                  // Initially, we're not waiting
        return function () {               // We return a throttled function
          if (!wait) {                   // If we're not waiting
            callback.call();           // Execute users function
            wait = true;               // Prevent future invocations
            setTimeout(function () {   // After a period of time
              wait = false;          // And allow future invocations
            }, limit);
          }
        };
      };

      const stickyElmScrollableParent = getScrollParent(stickyElm);
      stickyElm._originalOffsetTop = stickyElm.offsetTop;

      const detectStickiness = (elm, cb) => () => cb & cb(elm.offsetTop != elm._originalOffsetTop);

      const onSticky = isSticky => {
        stickyElm.classList.toggle('is_stuck', isSticky);
      };

      const scrollCallback = throttle(detectStickiness(stickyElm, onSticky), 100);
      stickyElmScrollableParent.addEventListener('scroll', scrollCallback);
    }

    this._activateStickyTableScrollBar();
  },
  _activateStickyTableScrollBar: function () {
    let fixedBarTemplate = '<div class="fixed-scrollbar"><div></div></div>',
      fixedBarCSS = {display: 'none', overflowX: 'scroll', position: 'fixed', width: '100%', bottom: 0};

    $('.fixed-scrollbar-container').each(function () {
      let $container = $(this),
        $bar = $(fixedBarTemplate).appendTo($container).css(fixedBarCSS);

      $bar[0].onscroll = function () {
        $container[0].scrollLeft = $bar[0].scrollLeft;
      };

      $bar.data('status', 'off');
    });

    let fixSize = function () {
      $('.fixed-scrollbar').each(function () {
        let $bar = $(this),
          $container = $bar.parent();

        $bar.children('div').height(1).width($container[0].scrollWidth);
        $bar.width($container.width());
        $bar[0].scrollLeft = $container[0].scrollLeft;
      });
    };

    $(window).on('load.fixedbar resize.fixedbar', function () {
      fixSize();
    });

    let scrollTimeout = null;

    $(window).on('scroll.fixedbar', function () {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        $('.fixed-scrollbar-container').each(function () {
          let $container = $(this),
            $bar = $container.children('.fixed-scrollbar');

          if ($bar.length) {
            let containerOffset = {top: $container.offset().top, bottom: $container.offset().top + $container.height()},
              windowOffset = {top: window.pageYOffset, bottom: window.pageYOffset + $(window).height()};
            if ((containerOffset.top > windowOffset.bottom) || (windowOffset.bottom > containerOffset.bottom)) {
              if ($bar.data('status') == 'on') {
                $bar.hide().data('status', 'off');
              }
            } else {
              if ($bar.data('status') == 'off') {
                $bar.show().data('status', 'on');
                $bar[0].scrollLeft = $container[0].scrollLeft;
              }
            }
          }
        });
      }, 50);
    });

    $(window).trigger('scroll.fixedbar');
  }

};

module.exports = BaseOrganic;
